/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {
  Collapse,
  Navbar,
  Input,
  NavbarToggler,
  NavbarBrand,
  Nav,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  Col,
  Popover,
  PopoverHeader,
  Button,
  PopoverBody,
  Row,
  FormGroup,
  Label,
  Table,
  Form,
} from "reactstrap";

import routes from "routes.js";
// import { authenticationService } from "services/Authentication.service.js";
import axios from "axios";
import Select from "react-select";
import { editMode } from "helpers/Utils.js";
// import UserPassword from "../User/User.password.component";
import Pagination from "components/Pagination/Pagination.js";
import {
  getToken,
  getCachedUser,
  authContext,
} from "../../services/adalConfig";

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      dropdownOpen: false,
      color: "transparent",
      suggestions: [],
      value: "",
      semesters: [],
      semesterId: "",
      campuses: [],
      campusId: "",
      openStudentModal: false,
      studentId: "",
      currentStudent: getCachedUser(),
      isPasswordModalOpen: false,
      popoverOpen: false,
      popoverName: "",
      popoverEmail: "",
      popoverI20: "",
      popoverStudents: [],
      itemsPerPage: 10,
      currentPage: 1,
      totalResults: 0,
    };

    this.toggle = this.toggle.bind(this);
    this.dropdownToggle = this.dropdownToggle.bind(this);
    this.sidebarToggle = React.createRef();

    this.timeout = 0;
  }

  toggle() {
    if (this.state.isOpen) {
      this.setState({
        color: "transparent",
      });
    } else {
      this.setState({
        color: "dark",
      });
    }
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  dropdownToggle(e) {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  getBrand() {
    let brandName = "Default Brand";

    let windowLocation = window.location.href;

    routes.map((prop, key) => {
      if (prop.children && prop.children.length > 0) {
        prop.children.forEach((child) => {
          if (windowLocation.indexOf(child.layout + child.path) !== -1)
            brandName = child.name;
        });
      } else {
        if (windowLocation.indexOf(prop.layout + prop.path) !== -1) {
          brandName = prop.name;
        }
      }

      return null;
    });
    return brandName;
  }

  openSidebar() {
    document.documentElement.classList.toggle("nav-open");
    this.sidebarToggle.current.classList.toggle("toggled");
  }

  logout() {
    authContext.logOut();
  }

  // function that adds color dark/transparent to the navbar on resize (this is for the collapse)
  updateColor() {
    if (window.innerWidth < 993 && this.state.isOpen) {
      this.setState({
        color: "dark",
      });
    } else {
      this.setState({
        color: "transparent",
      });
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateColor.bind(this));
  }

  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      this.sidebarToggle.current.classList.toggle("toggled");
    }
  }

  render() {
    const { currentStudent } = this.state;

    return (
      <Navbar
        color={
          this.props.location.pathname.indexOf("full-screen-maps") !== -1
            ? "dark"
            : this.state.color
        }
        expand="lg"
        className={
          this.props.location.pathname.indexOf("full-screen-maps") !== -1
            ? "navbar-absolute fixed-top"
            : "navbar-absolute fixed-top " +
              (this.state.color === "transparent" ? "navbar-transparent " : "")
        }
      >
        <Container fluid>
          <div className="navbar-wrapper">
            <div className="navbar-toggle">
              <button
                type="button"
                ref={this.sidebarToggle}
                className="navbar-toggler"
                onClick={() => this.openSidebar()}
              >
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </button>
            </div>
            <NavbarBrand href="/">{this.getBrand()}</NavbarBrand>
          </div>

          <NavbarToggler onClick={this.toggle}>
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
          </NavbarToggler>
          <Collapse
            isOpen={this.state.isOpen}
            navbar
            className="justify-content-end"
          >
            <div className="navbar-wrapper">
              <NavbarBrand>{currentStudent}</NavbarBrand>
            </div>

            <Nav navbar>
              <Dropdown
                nav
                isOpen={this.state.dropdownOpen}
                toggle={(e) => this.dropdownToggle(e)}
              >
                <DropdownToggle caret nav>
                  <i className="nc-icon nc-settings-gear-65" />
                  <p>
                    <span className="d-lg-none d-md-block">Some Actions</span>
                  </p>
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem
                    tag="a"
                    style={{ cursor: "pointer" }}
                    onClick={() => this.toggleisPasswordModalOpen()}
                  >
                    Settings
                  </DropdownItem>
                  <DropdownItem
                    tag="a"
                    onClick={() => this.logout()}
                    style={{ cursor: "pointer" }}
                  >
                    Log out
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </Nav>
          </Collapse>
        </Container>

        {/* <UserPassword
          isOpen={this.state.isPasswordModalOpen}
          toggle={this.toggleisPasswordModalOpen.bind(this)}
        /> */}
      </Navbar>
    );
  }

  onFormSubmit = (e) => {
    e.preventDefault();
    this.studentSearch();
  };

  handleInput = (e) => {
    const name = e.target.id;
    const value = e.target.value;

    this.setState({ [name]: value });
  };

  toggleisPasswordModalOpen = () => {
    return new Promise((resolve, reject) => {
      let mainState = this.state;
      mainState.isPasswordModalOpen = !mainState.isPasswordModalOpen;
      this.setState(mainState, resolve(true));
    });
  };

  togglePopover = () => {
    this.setState({ popoverOpen: !this.state.popoverOpen }, () => {
      if (this.state.popoverOpen)
        document.getElementById("popoverName").focus();
    });
  };

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });
  };
}

export default Header;
